<template>
  <div class="screen-container flex-column align-items-center justify-center" style="min-height: 900px;">
    <div class="myColumn flex-column" style="flex:none;">
        <div class="angle angle-lt"></div>
        <div class="angle angle-rt"></div>
        <div class="angle angle-lb"></div>
        <div class="angle angle-rb"></div>
        <div class="column-con flex-column flex-auto">
          <div class="logo-banner">
            <Chart :option="logoChartOpt" height="220px" backgroundLight="transparent" backgroundDark="transparent"></Chart>
          </div>
          <div class="login" style="margin:0 100px 40px 100px">
            <el-form :model="userForm" ref="userForm" label-width="auto">
              <el-form-item prop="username"
              :rules="[{ required: true, message: '此项不能为空'}]"
              >
                <el-input v-model="userForm.username" prefix-icon="el-icon-user" autocomplete="off" placeholder="请输入用户名" @keyup.enter.native="submitForm('userForm')"></el-input>
              </el-form-item>
              <el-form-item prop="password"
                :rules="[{ required: true, message: '此项不能为空'}]"
              >
                <el-input type="password" v-model="userForm.password" prefix-icon="el-icon-key" autocomplete="off" placeholder="请输入密码" @keyup.enter.native="submitForm('userForm')"></el-input>
              </el-form-item>
            </el-form>
            <div class="flex-row align-items-center justify-center">
              
              <el-button style="width: 100%;" type="primary" @click="submitForm('userForm')">登录</el-button>
            </div>
          </div>
          
        </div>
    </div>
  </div>
</template>

<script>
import Chart from "../components/Chart";
import crypto from "../common/crypto";
import logo from "@/assets/images/logo.png";
export default {
  name: 'Login',
  components:{
    Chart
  },
  data(){
    return {
      loading:false,
      logoChartOpt:{},
      userForm: {
        username:"",
        password: '',
      },
    }
  },
  computed:{
    title(){
      let val=this.$route.query.redirect||''
      if(val.indexOf('lng')>=0){
        return '天然气产业链行业数据'
      }
      else if(val.indexOf('oil')>=0){
        return '炼油行业运行监测系统'
      }
      else if(val.indexOf('newEnergy')>=0){
        return '中国新能源汽车产业大脑'
      }
      else{
        return '行业数据监测系统'
      }
    },
  },
  created(){
    this.$store.commit('stateInit')
    if(this.$route.query.status==401){
      this.$alert('登录状态已过期或账号已在其它设备登录', '请重新登录', {
        customClass:"custom-msgbox width-auto",
        confirmButtonText: '知道了',
        type: 'warning'
      })
      .then(() => {})
      .catch(()=>{})
    }
  },
  mounted(){
    console.log(this.$route)
    
   this.logoAnimation()
  },
  methods:{
    logoAnimation(){
      this.logoChartOpt={
        backgroundColor:'transparent',
        graphic: {
          elements: [
            {
              type: 'image',
              left: 'center',
              originX:75,
              originY:18,
              scaleX:0,
              scaleY:0,
              style: {
                image: logo,
                width:150,
                
              },
              keyframeAnimation: {
                duration: 1200,
                delay:0,
                loop: false,
                keyframes: [
                  {
                    // Stop for a while.
                    percent: 0,
                    easing: 'sinusoidalInOut',
                    scaleX:0,
                    scaleY:0,
                    y:80
                  },
                  {
                    // Stop for a while.
                    percent: 0.6,
                    easing: 'sinusoidalInOut',
                    scaleX:1,
                    scaleY:1,
                    y:80
                  },
                  {
                    percent: 1,
                    easing: 'sinusoidalInOut',
                    scaleX:1,
                    scaleY:1,
                    y:30
                  }
                ]
              }
            },
            {
              type: 'text',
              left: 'center',
              top: 90,
              style: {
                text: this.title,
                fontSize:50,
                fontWeight: 'bold',
                lineDash: [0, 200],
                lineDashOffset: 0,
                fill: 'transparent',
                stroke: '#fff',
                lineWidth: 1
              },
              keyframeAnimation: {
                duration: 2000,
                delay:1000,
                loop: false,
                keyframes: [
                  {
                    percent: 0.7,
                    style: {
                      fill: 'transparent',
                      lineDashOffset: 200,
                      lineDash: [200, 0],
                      stroke: '#fff',
                    }
                  },
                  {
                    // Stop for a while.
                    percent: 0.8,
                    style: {
                      fill: 'transparent',
                      lineWidth: 1
                    }
                  },
                  {
                    percent: 1,
                    style: {
                      fill: '#fff',
                      lineWidth: 0
                    }
                  }
                ]
              }
            },{
              type: 'text',
              left: 'center',
              originY:120,
              style: {
                text: '专 业 数 据   触 手 可 及',
                fontSize:18,
                fill: 'transparent',
                y:0
              },
              keyframeAnimation: {
                duration: 1000,
                delay:2200,
                loop: false,
                keyframes: [
                  {
                    percent: 0,
                    easing: 'sinusoidalInOut',
                    style: {
                      fill: 'transparent',
                      y:180
                    }
                  },
                  {
                    percent: 1,
                    easing: 'sinusoidalInOut',
                    style: {
                      fill: '#fff',
                      y:160
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    },
    submitForm(formName) {
      let input=document.getElementsByTagName('input')
      for(let i=0;i<input.length;i++){
        input[i].blur()
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {

            this.loginByUsername()
          
        } else {
          return false;
        }
      });
    },
    loginByUsername(){
      if(this.userForm.username==this.$store.state.authKey.username&&this.userForm.password==this.$store.state.authKey.password){
        this.success()
      }else{
        this.$message({message: '用户名或密码不正确',type:'warning',center:true,offset: Math.ceil(document.documentElement.clientHeight/2.4)})
      }
    },
  
    //登录回调
    success(){
        let res={token:new Date().getTime()}
        try{
          sessionStorage.setItem('loginRes_dataScreen',crypto.encrypt(res))
          sessionStorage.setItem('loginStamp_dataScreen',new Date().getTime())
        }catch{
          //
        }
        this.$store.commit('loginRes',res)
        this.$router.replace({
          path: this.$route.query.redirect||'/',
        })

    },
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login input{
  width:auto
}
.logo-banner{
  width:40vw;
  min-width: 700px;
  margin-bottom:30px;background:rgba(14, 56, 172,0.5);border-radius:5px;
  position: relative;
  overflow: hidden;
}
.logo-banner .version{
  background: #EA5404;
  color:#fff;
  width: 200px;
  text-align: center;
  padding: 5px 0;
  position: absolute;
  right: -70px;
  top: 15px;
  transform-origin: center;
  transform: rotateZ(45deg);
}

/* 栏目------------------------------------------------- */
$columnBackgroundLinear:linear-gradient(rgba(2, 15, 43, 0.8) 80%,rgba(6, 58, 88, 0.8));
$shineShadow:rgba(87, 165, 255, 0.6);
$columnRadiusColor:#8adaff;
$shineLine:rgba(90,191,255,0),rgba(90,191,255,1), rgba(90,191,255,0);
// $columnBackgroundLinear:linear-gradient(rgba(0, 0, 0, 0.8) 80%,rgba(31, 32, 34, 0.8));
// $shineShadow:rgba(150, 150, 150, 0.6);
// $columnRadiusColor:#d6d6d6;
// $shineLine:rgba(90,191,255,0),rgba(255, 255, 255,0.5), rgba(90,191,255,0);
.screen-container::before{
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-size: 100% 100%;
    background:url('~@/assets/images/body_bg.jpg') no-repeat;
    z-index: -1;
    // filter: hue-rotate(0deg) brightness(0.8) grayscale(80%);
}
.screen-container{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
    
    .page-sub-title{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size:24px;
        font-weight: bold;
        letter-spacing:10px;
        @include themeify{
            color: themed('textColorRaSub');
        };
    }
    .page-sub-title::before{
        content: "";
        flex: auto;
        height: 5px;
        border-radius: 3px;
        opacity: 0.5;
        background: linear-gradient(to right,$shineLine);
    }
    .page-sub-title::after{
        content: "";
        flex: auto;
        height: 5px;
        
        border-radius: 3px;
        opacity: 0.5;
        background: linear-gradient(to right,$shineLine);
    }
    .myColumn{
        margin-bottom: 20px;
        position: relative;
        border-radius: 10px;
        flex:auto;
        background: $columnBackgroundLinear;
        box-shadow: 0px 0px 10px $shineShadow;
        @include themeify{
            border: themed('borderColor') solid 1px;
        };
    }
    .myColumn .angle{
        height: 40px;
        width: 40px;
        position: absolute;
    }
    .myColumn .angle-lt{
        border-radius: 10px 0 0 0/10px 0 0 0;
        left: -2px;
        top: -2px;
        border-top: $columnRadiusColor solid 3px;
        border-left: $columnRadiusColor solid 3px;
    }
    .myColumn .angle-rt{
        border-radius: 0 10px 0 0/0 10px 0 0;
        right: -2px;
        top: -2px;
        border-top: $columnRadiusColor solid 3px;
        border-right: $columnRadiusColor solid 3px;
    }
    .myColumn .angle-lb{
        border-radius: 0 0 0 10px/0 0 0 10px;
        left: -2px;
        bottom: -2px;
        border-bottom: $columnRadiusColor solid 3px;
        border-left: $columnRadiusColor solid 3px;
    }
    .myColumn .angle-rb{
        border-radius: 0 0 10px 0/0 0 10px 0;
        right: -2px;
        bottom: -2px;
        border-bottom: $columnRadiusColor solid 3px;
        border-right: $columnRadiusColor solid 3px;
    }
    .myColumn::before{
        content: "";
        height: 40%;
        width: 3px;
        position: absolute;
        bottom: 20%;
        left: -2px;
        background: linear-gradient($shineLine);

    }
    .myColumn::after{
        content: "";
        height: 40%;
        width: 3px;
        position: absolute;
        top: 20%;
        right: -2px;
        background: linear-gradient($shineLine);
    }
    .myColumn .column-con{
        position: relative;
        padding:10px;
        box-sizing: border-box;
        border-radius: 10px;
        box-shadow: 0px 0px 25px $shineShadow inset;
        @include themeify{
            color: themed('textColor');
            
        };

    }
    .myColumn .column-con::before{
        content: "";
        width: 40%;
        height: 3px;
        position: absolute;
        bottom: -2px;
        left: 20%;
        background: linear-gradient(to right,$shineLine);
    }
    .myColumn .column-con::after{
        content: "";
        width: 40%;
        height: 3px;
        position: absolute;
        top: -2px;
        right: 20%;
        background: linear-gradient(to right,$shineLine);
    }
    .myColumn .column-title{
        font-size: 16px;
        font-weight: bold;
        position: relative;
        margin-left: 30px;
        @include themeify{
            color: themed('textColorRaSub');
        };
    }
    .myColumn .column-title::before{
        content: "";
        width:20px;
        height: 5px;
        position: absolute;
        top: 11px;
        left: -30px;
        border-radius: 3px;
        opacity: 0.5;
        background: linear-gradient(to right,$shineLine);
    }
    .myColumn .column-title::after{
        content: "";
        width:50px;
        height: 5px;
        position: absolute;
        top: 11px;
        right: -60px;
        border-radius: 3px;
        opacity: 0.5;
        background: linear-gradient(to right,$shineLine);
    }
}
</style>
